import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

const DeleteConfirmationModal = ({ open, onClose, standardToDelete, handleDeleteStandard, loading }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningIcon sx={{ color: "#dc2626" }} />
        Confirm Deletion
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          Are you sure you want to delete the standard "{standardToDelete}"? This action cannot be undone and will
          remove all associated requirements.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            color: "#dc2626",
            borderColor: "#dc2626",
            borderRadius: "4px",
            cursor: "pointer",
            border: "1px solid #dc2626",
            backgroundColor: "transparent",
          }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDeleteStandard}
          disabled={loading}
          variant="contained"
          sx={{ bgcolor: "#dc2626", "&:hover": { bgcolor: "#b91c1c" } }}
        >
          {loading ? "Deleting..." : "Delete Standard"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
